import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IBatchMoveDriveItemsParams {
  filePlacementIds?: string[];
  folderIds?: string[];
  destinationFolderId: string;
}

export async function batchMoveDriveItems({
  filePlacementIds,
  folderIds,
  destinationFolderId,
}: IBatchMoveDriveItemsParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/file-placement/move/bulk', {
    method: 'POST',
    body: { filePlacementIds, folderIds, destinationFolderId },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to move items',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
